export const words = [
    { word: 'apple', category: 'fruit' },
    { word: 'banana', category: 'fruit' },
    { word: 'orange', category: 'fruit' },
    { word: 'grape', category: 'fruit' },
    { word: 'kiwi', category: 'fruit' },
  
    { word: 'computer', category: 'technology' },
    { word: 'phone', category: 'technology' },
    { word: 'laptop', category: 'technology' },
    { word: 'robot', category: 'technology' },
    { word: 'camera', category: 'technology' },
  
    { word: 'mountain', category: 'geography' },
    { word: 'ocean', category: 'geography' },
    { word: 'river', category: 'geography' },
    { word: 'valley', category: 'geography' },
    { word: 'desert', category: 'geography' },
  
    { word: 'guitar', category: 'music' },
    { word: 'piano', category: 'music' },
    { word: 'violin', category: 'music' },
    { word: 'drums', category: 'music' },
    { word: 'flute', category: 'music' },
  
    { word: 'flower', category: 'nature' },
    { word: 'tree', category: 'nature' },
    { word: 'bird', category: 'nature' },
    { word: 'butterfly', category: 'nature' },
    { word: 'sunflower', category: 'nature' },
    // Add more words as needed
  ];